import { useEffect, useState } from "react";
import { InputTable } from "./InputTable";
import { Card } from "@/components/Shared/Card";
import { Separator } from "@/components/ui/separator";
import { useApi } from "@/hooks/useApi";
import { useParams } from "react-router-dom";
import { tourSteps } from "./InputTour";
import { useTour } from "@reactour/tour";
import { HelpCircleIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

export function InputDashboard() {
	const { setIsOpen, setCurrentStep, setSteps } = useTour();

	useEffect(() => {
		if (!setSteps) throw new Error("setSteps is not defined");
		setSteps(tourSteps);
	}, [setSteps]);

	const initTour = () => {
		setIsOpen(true);
		setCurrentStep(0);
	};

	return (
		<Card>
			<h1 className="text-xl font-bold"></h1>

			<div className="flex justify-between" data-tour-id="title">
				<h1 className="text-xl font-bold">Imputar Consumos</h1>
				<Button variant="ghost" size="icon" onClick={initTour}>
					<HelpCircleIcon className="size-6" />
				</Button>
			</div>
			<Separator />
			<InputTablePick />
		</Card>
	);
}

function InputTablePick() {
	const params = useParams();
	if (params.inputId == "new") {
		return <InputTableNew />;
	}
	if (params.inputId == null) {
		return <InputTableNew />;
	}
	return <InputTableEdit />;
}

function InputTableEdit() {
	const api = useApi();
	const params = useParams();

	const result = api.useQuery(
		"get",
		"/v1/Empresa/Imputaciones/{idImputacion}",
		{
			params: {
				path: {
					idImputacion: params.inputId ?? "",
				},
			},
		},
	);

	return <InputTable imputacion={result} />;
}

function InputTableNew() {
	const today = new Date();

	const [newInput] = useState({
		idImputacion: "new",
		lineas: [],
		desde: today.toISOString(),
		hasta: today.toISOString(),
	});

	return (
		<InputTable
			imputacion={{
				isPending: false,
				isError: false,
				data: newInput,
				error: undefined,
				refetch: () => Promise.resolve(),
			}}
		/>
	);
}
